import { csrfToken as sharedCsrfToken } from "@circle-react/helpers/csrfToken";

export const csrfToken = () => sharedCsrfToken() ?? "";
